import { Sun, Moon, Laptop } from 'lucide-react';
import { useTheme } from '@/contexts/theme-context';
import { cn } from '@/lib/utils';

export function ThemeToggle() {
  const { theme, setTheme, effectiveTheme } = useTheme();

  const getSelectorTransform = () => {
    if (theme === 'light') return 'translateX(0%)';
    if (theme === 'system') return 'translateX(calc(100% - 2px))';
    if (theme === 'dark') return 'translateX(calc(200% - 4px))';
    return 'translateX(0%)';
  };

  const isLightActive = effectiveTheme === 'light';
  const isDarkActive = effectiveTheme === 'dark';
  const isSystemSelected = theme === 'system';


  return (
    <div className="relative flex items-center justify-around p-1 rounded-full bg-muted w-36 h-10 shadow-inner">
      <div
        className="absolute top-0.5 left-0.5 w-1/3 h-[calc(100%-4px)] rounded-full bg-background shadow-sm transition-transform duration-300 ease-in-out"
        style={{ transform: getSelectorTransform() }}
      />

      <button
        type="button"
        aria-label="Switch to light theme"
        onClick={() => setTheme('light')}
        className={cn(
          "z-10 p-1 rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-muted transition-colors duration-200",
          isLightActive ? "text-primary" : "text-muted-foreground hover:text-foreground"
        )}
      >
        <Sun className="h-5 w-5" />
      </button>

      <button
        type="button"
        aria-label="Switch to system theme"
        onClick={() => setTheme('system')}
        className={cn(
          "z-10 p-1 rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-muted transition-colors duration-200",
          isSystemSelected ? "text-primary" : "text-muted-foreground hover:text-foreground"
        )}
      >
        <Laptop className="h-5 w-5" />
      </button>

      <button
        type="button"
        aria-label="Switch to dark theme"
        onClick={() => setTheme('dark')}
        className={cn(
          "z-10 p-1 rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-muted transition-colors duration-200",
          isDarkActive ? "text-primary" : "text-muted-foreground hover:text-foreground"
        )}
      >
        <Moon className="h-5 w-5" />
      </button>
    </div>
  );
}
